module.exports = __webpack_public_path__ + "img/icon-play.cf10b4e2.svg";